import { useTranslation } from "react-i18next";

export const CANCEL_REASONS = ["too_expensive", "not_used", "missing_feature", "closing", "other_tool", "technical", "other"];

export default function CancelReasonPicker({ code, text, onCode, onText, withNoAnswer = true, prefix = "cancel-reason" }) {
  const { t } = useTranslation();
  const list = withNoAnswer ? [...CANCEL_REASONS, "no_answer"] : CANCEL_REASONS;
  return (
    <div className="space-y-2" data-testid={prefix}>
      <div className="grid gap-1.5">
        {list.map((k) => (
          <label key={k} className={`flex items-center gap-2 p-2.5 rounded-xl border text-sm cursor-pointer ${code === k ? "border-primary-c bg-primary-c/5" : "border-c bg-white"}`}>
            <input type="radio" name={prefix} checked={code === k} onChange={() => onCode(k)} className="accent-[var(--primary)]" data-testid={`${prefix}-${k}`} />
            {t(`cancel.r_${k}`)}
          </label>
        ))}
      </div>
      {code && code !== "no_answer" && (
        <textarea value={text} onChange={(e) => onText(e.target.value)} maxLength={1000} rows={3}
          placeholder={code === "other" ? t("cancel.text_required") : t("cancel.text_optional")}
          className="input-c text-sm" data-testid={`${prefix}-text`} />
      )}
    </div>
  );
}
